export default __webpack_public_path__ + "static/media/AO-3.d18ed5a0.jpg";